// --- Header Parts ---
import MegaMenu from "../parts/header/MegaMenu";
import UserActions from "../parts/header/UserActions";

// --- Footer Parts ---
import AppPanels from "../parts/footer/AppPanels";
import FixedActionsLeft from "../parts/footer/FixedActionsLeft";
import FixedActionsRight from "../parts/footer/FixedActionsRight";
import MobileBottomNav from "../parts/footer/MobileBottomNav";
import SettingsPopup from "../parts/footer/SettingsPopup/SettingsPopup";

// --- Redux Slices (So themes can hook into Header/Footer state) ---
import { toggleSettingsPopup } from "../parts/footer/SettingsPopup/settingsPopupSlice";

export const parts = {
  header: {
    MegaMenu,
    UserActions,
  },
  footer: {
    AppPanels,
    FixedActionsLeft,
    FixedActionsRight,
    MobileBottomNav,
    SettingsPopup,
  },
  actions: {
    toggleSettingsPopup,
  },
};
